document.addEventListener('DOMContentLoaded', () => {
  const brandSlider = new Swiper('.swiper-brand', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 2,
    spaceBetween: 40,
    breakpoints: {
      576: {
        slidesPerView: 3,
        spaceBetween: 60,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 60,
      },
      992: {
        slidesPerView: 5,
        spaceBetween: 80,
      },
      1260: {
        slidesPerView: 6,
        spaceBetween: 80,
      },
      1500: {
        slidesPerView: 7,
        spaceBetween: 80,
      },
      1680: {
        slidesPerView: 8,
        spaceBetween: 100,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
});
